import { useTranslation } from "react-i18next";
import { ArrowRight, X } from "lucide-react";
import { Button } from "components/common/Button";
import { TruncatedTextTooltip } from "components/common/TruncatedTextTooltip";
import { ComparedPlanSelect } from "../ComparedPlanSelect";
import type { PlanComparisonHeaderProps } from "./types";

export const PlanComparisonHeader = ({
  beforePlanName,
  candidateRecords,
  afterPlanRecord,
  onAfterPlanSelect,
  onClose,
}: PlanComparisonHeaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="relative px-4 py-2 pr-12 sm:px-6 sm:pr-14">
      <h2 className="text-base font-semibold text-gray-900">
        {t("smartSurveyor.planComparison.title")}
      </h2>
      <div className="mt-1 flex flex-col gap-1.5 lg:flex-row lg:items-center lg:gap-3">
        <div className="flex min-w-0 items-baseline gap-1.5 text-sm">
          <span className="flex-shrink-0 text-gray-500">
            {t("smartSurveyor.planComparison.beforePlan")}:
          </span>
          <TruncatedTextTooltip
            text={beforePlanName}
            className="min-w-0 font-medium text-gray-700"
          />
        </div>
        {afterPlanRecord !== null && (
          <>
            <ArrowRight
              size={14}
              className="hidden flex-shrink-0 text-gray-400 lg:block"
            />
            <div className="flex min-w-0 items-center gap-1.5 text-sm lg:flex-shrink-0">
              <span className="flex-shrink-0 text-gray-500">
                {t("smartSurveyor.planComparison.afterPlan")}:
              </span>
              <ComparedPlanSelect
                candidateRecords={candidateRecords}
                comparedPlanRecord={afterPlanRecord}
                onComparedPlanSelect={onAfterPlanSelect}
                className="min-w-0 flex-1 lg:w-80 lg:flex-none"
              />
            </div>
          </>
        )}
      </div>
      <Button
        size="sm"
        onClick={onClose}
        className="absolute right-3 top-2 flex-shrink-0"
      >
        <X size={18} />
      </Button>
    </div>
  );
};
